import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";

import { ReactComponent as WarningIcon } from "../img/icons/warning.svg";
import Summary from "../components/Summary"
import { Container } from "../layout/Container";
import NavTab from "../components/NavTab";
import Button from "../components/Button";
import SingleElimination from "../components/SingleElimination";
import { useParams } from "react-router-dom";
import axios from "axios";
import { connect, useSelector, useDispatch } from "react-redux";
import { logout, editRounds } from "../state/action-creator/index";
import DoubleElimination from "../components/DoubleElimination";
import RoundRobin from "../components/RoundRobin";
import { bindActionCreators } from "redux";
import { actionCreators } from "../state/index";

import Modal from "../components/Modal";
import AuthModal from "../components/modals/Authentication";
import ENV_CONFIG from "../config/environment-unified";
import useTranslation from "../hooks/useTranslation";

const TournamentDetails = () => {
  const dispatch = useDispatch();
  const { editRounds } = bindActionCreators(actionCreators, dispatch);
  const { t } = useTranslation();
  const [index, setIndex] = useState(1);
  const [struct, setStruct] = useState("Brackets");
  const [tourData, setTourData] = useState({});
  const list = [
    t("tournamentdetails.tab_about", "About"),
    t("tournamentdetails.tab_summary", "Summary"),
    struct,
    t("tournamentdetails.tab_rules", "Rules"),
  ];
  let { id } = useParams();
  const [data, setData] = useState({});
  useEffect(() => {
    async function fetchData() {
      if (!id) {
        console.log("❌ No tournament ID provided");
        return;
      }

      let tournament = {}
      try {
        const endpoint = ENV_CONFIG.TOURNAMENT_ENDPOINT;
        if (!endpoint) {
          console.error("❌ Tournament endpoint not configured");
          toast.error(t("tournamentdetails.configuration_error", "Configuration error"));
          return;
        }

        const url = endpoint + "/getTournament/" + id;
        console.log("🔍 Fetching tournament with URL:", url);
        tournament = await axios.get(url, { withCredentials: true });
        setTourData(tournament.data)
        setData(tournament.data);
        console.log("✅ Tournament data:", tournament.data)
        setStruct(tournament.data.structure === "robin" ? "Standing" : "Brackets")
      } catch (err) {
        console.error("❌ Error fetching tournament:", err);
        if (err.response?.status === 404) {
          toast.error(t("tournamentdetails.tournament_not_found", "Tournament not found"));
        } else if (err.response?.status === 401) {
          toast.error(t("tournamentdetails.unauthorized_access", "Unauthorized access"));
        } else {
          toast.error(t("tournamentdetails.error_loading_tournament", "Error loading tournament"));
        }
      }
    }
    fetchData();
  }, [id, t]);
  useEffect(() => {
    editRounds(tourData.bracket, tourData.structure, tourData.adminId);
  }, [tourData, editRounds])
  return (
    <>
      <CoverStyle cover={data.coverImg}>
        <h1>{data.tournametName}</h1>
      </CoverStyle>
      <Container style={{ position: "relative" }}>
        <NavTab
          rightComponent={<TournamentStatus showJoin={true} data={data} />}
          list={list}
          index={index}
          setIndex={setIndex}
        />
        {index === 1 && (
          <About
            data={data}
            setData={(e) => {
              setData(e);
            }}
          />
        )}
        {index === 2 && <Summary />}
        {index === 3 && <Bracket tournament={data} />}
        {index === 4 && <Rules />}
      </Container>
    </>
  );
};
export default TournamentDetails;

const About = (props) => {
  const { t } = useTranslation();
  return (
    <AboutStyle>
      <div>
        <h6>{t("tournamentdetails.attention_title", "Attention Fortniters")}</h6>
        <p className="small">
          {props.data.attentionNote || props.data.description || t("tournamentdetails.welcome_default", "Welcome to this exciting tournament!")}
        </p>
        <hr />
        <h6>{t("tournamentdetails.how_it_works", "How it works")}</h6>
        <p className="small">
          {props.data.howItWorks || props.data.rules || t("tournamentdetails.rules_announced_soon", "Tournament rules will be announced soon.")}
        </p>
        <hr />
        <footer>
          <div>
            <h6>{t("tournamentdetails.game_mode", "Game Mode")}</h6>
            <p>{props.data.gameMode || t("tournamentdetails.single_elimination", "Single Elimination")}</p>
          </div>
          <hr />
          <div>
            <h6>{t("tournamentdetails.game", "Game")}</h6>
            <p>{props.data.gameName || props.data.gameId || t("tournamentdetails.tournament_game", "Tournament Game")}</p>
          </div>
          <hr />
          <div>
            <h6>{t("tournamentdetails.prize", "Prize")}</h6>
            <p>{props.data.prize ? `$${props.data.prize}` : t("tournamentdetails.prize_tbd", "Prize TBD")}</p>
          </div>
        </footer>
      </div>
      <img src={props.data.posterImg || props.data.PosterImg} alt="" />
    </AboutStyle>
  );
};
export const Bracket = ({ tournament, tournamentId: explicitId }) => {
  const dispatch = useDispatch();
  const { editRounds } = bindActionCreators(actionCreators, dispatch);
  const { id: routeId } = useParams();
  const { t } = useTranslation();
  const id = explicitId || routeId;
  const [hasMatches, setHasMatches] = useState(false);
  const [structure, setStructure] = useState(null);
  
  useEffect(() => {
    if (!id) {
      console.log("❌ No tournament ID for bracket");
      return;
    }

    axios.get(ENV_CONFIG.TOURNAMENT_ENDPOINT + "/getTournament/" + id).then((res) => {
      console.log("✅ Bracket data loaded:", res.data);
      setHasMatches(res.data.bracket && res.data.bracket.length > 0);
      setStructure(res.data.structure);
      editRounds(res.data.bracket, res.data.structure, res.data.adminId);
    }).catch((x) => {
      console.error("❌ Error loading bracket:", x);
      editRounds(null, null)
    });
  }, [editRounds, id])

  if (!hasMatches) {
    return (
      <EmptyBracketState>
        <h3>{t("tournamentdetails.brackets_available_when_started", "Brackets will be available once the tournament starts")}</h3>
        <p>{t("tournamentdetails.wait_for_organizer_start", "Please wait for the tournament organizer to start the tournament.")}</p>
      </EmptyBracketState>
    );
  }

  if (structure === "d_elim") {
    return <>
      <DoubleElimination stream={true} />
    </>
  } else if (structure === "s_elim") {
    return <SingleElimination stream={true} />;
  } else if (structure === "robin") {
    return <RoundRobin stream={true} />
  } else return <></>
};

const EmptyBracketState = styled.div`
  text-align: center;
  padding: 40px;

  h3 {
    margin: 0 0 8px 0;
    color: ${({ theme }) => theme.color.darkerText};
  }

  p {
    margin: 0;
    color: ${({ theme }) => theme.color.lighterText};
  }
`;

const Rules = () => {
  const [data, setData] = useState({});
  let { id } = useParams();
  const { t } = useTranslation();
  
  useEffect(() => {
    async function fetchData() {
      if (!id) return;
      
      try {
        const endpoint = ENV_CONFIG.TOURNAMENT_ENDPOINT;
        const url = endpoint + "/getTournament/" + id;
        const tournament = await axios.get(url, { withCredentials: true });
        setData(tournament.data);
      } catch (err) {
        console.error("❌ Error fetching tournament rules:", err);
      }
    }
    fetchData();
  }, [id]);

  return (
    <div style={{ padding: '20px' }}>
      <h3>{t("tournamentdetails.tournament_rules", "Tournament Rules")}</h3>
      {data.rules ? (
        <div style={{ 
          background: '#f5f5f5', 
          padding: '20px', 
          borderRadius: '8px',
          lineHeight: '1.6'
        }}>
          <pre style={{ 
            whiteSpace: 'pre-wrap', 
            fontFamily: 'inherit',
            margin: 0
          }}>
            {data.rules}
          </pre>
        </div>
      ) : (
        <div style={{ 
          textAlign: 'center', 
          padding: '40px',
          color: '#666'
        }}>
          <h4>{t("tournamentdetails.no_rules_yet", "No rules have been set for this tournament yet.")}</h4>
          <p>{t("tournamentdetails.organizer_updates_rules", "The tournament organizer will update the rules before the tournament starts.")}</p>
        </div>
      )}
    </div>
  );
};

export const TournamentStatus = ({ showJoin }) => {
  const userId = useSelector(state => state.user.data._id);
  let { id } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState({});
  const [joined, setJoined] = useState(false)
  const [userApproved, setUserApproved] = useState(false)

  useEffect(() => {
    async function fetchData() {
      if (!id) {
        console.log("❌ No tournament ID for status");
        return;
      }

      let tournament = {}
      try {
        console.log("🔍 Fetching tournament status for ID:", id);
        tournament = await axios.get(ENV_CONFIG.TOURNAMENT_ENDPOINT + "/getTournament/" + id, { withCredentials: true });
        setData(tournament.data);
        setJoined(tournament?.data?.isJoined)
        setUserApproved(tournament?.data?.userApproved)
        console.log("✅ Tournament status:", tournament.data)
        editRounds(tournament.data.bracket, tournament.data.structure, tournament.data.adminId);
      } catch (err) {
        console.error("❌ Error fetching tournament status:", err);
        if (err.response?.status === 401) logout();
      }
    }
    fetchData();
  }, [id]);
  const isLoggedIn = useSelector(state => state.user.isLoggedIn)
  const [modal, setModal] = useState(false);
  const handleJoinTournament = () => {
    if (!isLoggedIn) setModal(true);
    else
      axios.post(ENV_CONFIG.JOIN_TOURNAMENT_ENDPOINT, { tournmentID: id, PlayerID: userId }, { withCredentials: true }).then((x) => {
        setJoined(true)
        if (data.adminId === userId) {
          setUserApproved(true)
          toast.success(t("tournamentdetails.joined_success", "Joined successfully"));
          setJoinLabel(t("tournamentdetails.participant", "Participant"))
        }
        else
          setJoinLabel(t("tournamentdetails.pending", "Pending"))
      }).catch((x) => {
        console.log(x)
      });
  };
  const [joinLabel, setJoinLabel] = useState((data.userApproved) ? t("tournamentdetails.participant", "Participant") : t("tournamentdetails.pending", "Pending"))
  useEffect(() => {
    setJoinLabel((data.userApproved) ? t("tournamentdetails.participant", "Participant") : t("tournamentdetails.pending", "Pending"))
  }, [data.userApproved, t])
  const [leaveModal, setLeaveModal] = useState(false);
  const handleLeave = () => {
    axios.post(ENV_CONFIG.LEAVE_TOURNAMENT_ENDPOINT, { tournmentID: id, PlayerID: userId }, { withCredentials: true }).then((x) => {
      setJoined(false)
      setUserApproved(false)
      toast.success(t("tournamentdetails.left_success", "Left successfully"));
      setJoinLabel(t("tournamentdetails.join", "Join"))
    }).catch((x) => {
      console.log(x)
    });
    setLeaveModal(false)
  }

  return (
    <div style={{ display: "flex" }}>
      <Modal isOpen={leaveModal} onRequestClose={() => setLeaveModal(false)} hideModal={() => setLeaveModal(false)}>
        <div style={{ textAlign: "center" }}>
          <WarningIcon />
          <p className="large" style={{ margin: "30px 0" }}>
            {t("tournamentdetails.leave_confirm_text", "Are you sure you want to leave the tournament?")}
          </p>
          <div style={{ display: "flex" }}>
            <Button
              variant="secondary"
              onClick={() => setLeaveModal(false)}
              style={{ flex: "1", marginRight: "10px" }}
            >
              {t("common.cancel", "Cancel")}
            </Button>
            <Button variant="danger" onClick={handleLeave} style={{ flex: "1" }}>
              {t("tournamentdetails.leave", "Leave")}
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={modal}
        onRequestClose={() => setModal(false)}
        hideModal={() => setModal(false)}
      >
        <AuthModal tabIndex={1} hideModal={() => setModal(false)} />
      </Modal>
      {(!data?.isActive && (!joined || !data?.isJoined) && showJoin && (!userApproved || !data?.userApproved))
        ? <Button style={{ marginRight: "15px" }} outline size="small" onClick={handleJoinTournament}>{t("tournamentdetails.join_tournament", "Join Tournament")}</Button>
        : ""}
      <TournamentStatusStyle participant={userApproved} full={data?.numberOfPlayers >= data?.size}>
        <span>
          {data?.numberOfPlayers < 10 ? "0" : ""}
          {data?.numberOfPlayers}/
        </span>
        <span>{data?.size}</span>
        {data?.numberOfPlayers >= data?.size && <span>{t("tournamentdetails.full", "full")}</span>}
        {((!userApproved && !joined) || data?.Active) ? <></> : ((data?.numberOfPlayers >= data?.size) ? <></> :
          (!userApproved) ?
            <Button
              style={{ width: "100px", marginLeft: "12px" }}
              size="small"
              variant="primary"
              onMouseEnter={() => setJoinLabel(t("common.cancel", "Cancel"))}
              onMouseLeave={() => setJoinLabel(t("tournamentdetails.pending", "Pending"))}
              onClick={() => setLeaveModal(true)}
            >
              {joinLabel}
            </Button>
            : <Button
              style={{ width: "100px", marginLeft: "12px" }}
              size="small"
              variant="primary"
              onMouseEnter={() => setJoinLabel(t("tournamentdetails.leave", "Leave"))}
              onMouseLeave={() => setJoinLabel(t("tournamentdetails.participant", "Participant"))}
              onClick={() => setLeaveModal(true)}
            >
              {joinLabel}
            </Button>)}
      </TournamentStatusStyle>
    </div>
  );
};
const TournamentStatusStyle = styled.div`
  display: flex;
  align-items: center;
  span {
    :nth-child(1),
    :nth-child(2) {
      color: ${({ full, theme }) => (full ? theme.color.danger : theme.color.primaryText)};
      font-family: "Poppins Bold";
    }
    :nth-child(1) {
      font-size: 18px;
    }
    :nth-child(2) {
      font-size: 12px;
      padding-left: 3px;
    }
    :nth-child(3) {
      padding: 3px 10px;
      margin-left: 15px;
      color: #ffffff;
      border-radius: 4px;
      font-size: 14px;
      font-family: "Poppins SemiBold";
      text-transform: capitalize;
      background-color: ${({ full }) => (full ? "#EE4C50" : "#4569FF")};
    }
  }
`;
const AboutStyle = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  & > img {
    margin-top: 10px;
    border-radius: 23px;
    object-fit: cover;
    width: clamp(286px, 286px, 286px);
    height: clamp(400px, 400px, 400px);
  }

  & > div {
    max-width: 625px;
    & > h6 {
      margin-bottom: 12px;
    }
    h6 {
      color: ${({ theme }) => theme.color.primaryText};
    }
    footer {
      width: 400px;
      & > hr {
        margin-top: 15px;
        margin-bottom: 15px;
      }
      & > div {
        display: flex;
        p {
          margin-left: auto;
        }
      }
    }
  }
`;

const CoverStyle = styled.header`
  height: 28vw;
  width: 100%;
  margin-bottom: 35px;
  background-color: ${({ theme }) => theme.color.secondaryBg};
  border-radius: 0px 0px 20px 20px;
  background-image: url("${({ cover }) => cover}");
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;

  h1 {
    color: white;
    position: absolute;
    bottom: 23px;
    left: 32px;
  }
`;
connect({ logout })(TournamentDetails);
connect({ editRounds })(Bracket);